"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
exports.getFilteredSuburbs = getFilteredSuburbs;
exports.getMemberMeta = getMemberMeta;
exports.getSiteMetadata = getSiteMetadata;
exports.loadFilteredSuburbs = loadFilteredSuburbs;
exports.loadMemberMeta = loadMemberMeta;
exports.loadSiteMetadata = loadSiteMetadata;
var _objectSpread3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _meta = require("./utils/meta");
var _utils = require("./utils");
var _createMappedReducer;
/* eslint-disable no-unused-vars, spaced-comment */
var LOADING_METADATA = 'LOADING_OFFICE_METADATA';
var LOADED_METADATA = 'LOADED_OFFICE_METADATA';
var LOADING_MEMBER_METADATA = 'LOADING_MEMBER_METADATA';
var LOADED_MEMBER_METADATA = 'LOADED_MEMBER_METADATA';
var LOAD_FILTERED_SUBURBS = 'LOAD_FILTERED_SUBURBS';
var DEFAULT_MEMBER_META = (0, _freeze["default"])((0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, _utils.DEFAULT_LOADABLE), {}, {
  hasListings: false
}));
var DEFAULT_SITEMETADATA = (0, _freeze["default"])((0, _objectSpread3["default"])({}, _utils.DEFAULT_LOADABLE));
var getKey = function getKey(statusCodes, typeCodes) {
  return (0, _stringify["default"])({
    statusCodes: statusCodes,
    typeCodes: typeCodes
  });
};
function shouldFetchMetadata(state) {
  if (state.loading || state.loaded || state.error) {
    return false;
  }
  return true;
}
function loadAgentMetadata(agentId, data) {
  return (0, _objectSpread3["default"])({
    type: LOADED_MEMBER_METADATA,
    agentId: agentId
  }, data);
}
function getMemberMeta(state, memberId) {
  return state.member[memberId] || DEFAULT_MEMBER_META;
}
function getSiteMetadata(state) {
  return state.site.loaded ? state.site : DEFAULT_SITEMETADATA;
}
function loadSiteMetadata(api, ids, priceInterval) {
  return function dispatchLoadSiteMetadata(dispatch, getState) {
    if (!shouldFetchMetadata(getSiteMetadata(getState().meta))) {
      return _promise["default"].resolve(getSiteMetadata(getState().meta));
    }
    dispatch({
      type: LOADING_METADATA
    });
    return api(priceInterval, ids).then(function (data) {
      return dispatch((0, _objectSpread3["default"])({
        type: LOADED_METADATA
      }, data));
    }).then(function () {
      return getSiteMetadata(getState().meta);
    });
  };
}
function loadMemberMeta(api, agentId, ids, allowOtherTransactions) {
  return function dispatchloadMemberMeta(dispatch, getState) {
    if (!shouldFetchMetadata(getMemberMeta(getState().meta, agentId))) {
      return _promise["default"].resolve(getMemberMeta(getState().meta, agentId));
    }
    dispatch({
      type: LOADING_MEMBER_METADATA,
      agentId: agentId
    });
    return api(agentId, ids, allowOtherTransactions).then(function (data) {
      return dispatch(loadAgentMetadata(agentId, data));
    }).then(function () {
      return getMemberMeta(getState().meta, agentId);
    });
  };
}
function loadFilteredSuburbs(statusCode, typeCode, subTypeCode) {
  return {
    type: LOAD_FILTERED_SUBURBS,
    statusCode: statusCode,
    typeCode: typeCode,
    subTypeCode: subTypeCode
  };
}
function getFilteredSuburbs(state, statusCode, typeCode, subTypeCode) {
  return state.filteredSuburbs[getKey(statusCode, typeCode, subTypeCode)] || [];
}
var initialState = (0, _freeze["default"])({
  error: undefined,
  filteredSuburbs: {},
  site: {},
  member: {}
});
function reduceLoadingSiteMetadata(state, action) {
  return (0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, state), {}, {
    site: {
      loading: true
    }
  });
}
function reduceLoadedSiteMetadata(state, action) {
  delete action.type; // eslint-disable-line no-param-reassign
  return (0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, state), {}, {
    site: (0, _objectSpread3["default"])({
      loaded: true,
      loading: false
    }, action)
  });
}
function reduceLoadingMemberMetadata(state, action) {
  var _member;
  return (0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, state), {}, {
    member: (_member = {}, _member[action.agentId] = {
      loading: true,
      loaded: false,
      hasListings: false
    }, _member)
  });
}
function reduceLoadedMemberMetadata(state, action) {
  var _member2;
  delete action.type; // eslint-disable-line no-param-reassign
  return (0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, state), {}, {
    member: (_member2 = {}, _member2[action.agentId] = (0, _objectSpread3["default"])({
      loaded: true,
      loading: false,
      hasListings: !!action.total,
      total: action.total
    }, action.typeCode), _member2)
  });
}
function reduceFilteredSuburbs(state, action) {
  var _objectSpread2;
  var statusCode = action.statusCode,
    typeCode = action.typeCode,
    subTypeCode = action.subTypeCode;
  var key = getKey(statusCode, typeCode, subTypeCode);
  if (!state.site.typeKey) return state;
  if (state.filteredSuburbs[key]) return state;
  return (0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, state), {}, {
    filteredSuburbs: (0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, state.filteredSuburbs), {}, (_objectSpread2 = {}, _objectSpread2[key] = (0, _meta.getSuburbs)(state.site.typeKey, statusCode, typeCode, subTypeCode), _objectSpread2))
  });
}
var reducer = (0, _utils.createMappedReducer)((_createMappedReducer = {}, _createMappedReducer[LOADING_METADATA] = reduceLoadingSiteMetadata, _createMappedReducer[LOADED_METADATA] = reduceLoadedSiteMetadata, _createMappedReducer[LOADING_MEMBER_METADATA] = reduceLoadingMemberMetadata, _createMappedReducer[LOADED_MEMBER_METADATA] = reduceLoadedMemberMetadata, _createMappedReducer[LOAD_FILTERED_SUBURBS] = reduceFilteredSuburbs, _createMappedReducer), initialState);
var _default = exports["default"] = reducer;